import React from "react";
import {CarInfo, DriverCommonInfo} from "../model/rideInfo";
import "../styles/DriverInfoCard.css";
import {FormattedMessage} from "react-intl";
import {carColors} from "../model/constants";
import {ReactComponent as DriverPhoto} from "../image/driver-photo.svg";

export function DriverInfoCard({driver, car}: {driver: DriverCommonInfo; car: CarInfo}) {
    const color = (car.color ?? "").toLowerCase();
    return (
        <div className="driver-row">
            <div className="driver-photo-wrapper">
                {driver.photo ? (
                    <img src={driver.photo} className="vehicle badge" alt={driver.name} />
                ) : (
                    <div className="badge">
                        <DriverPhoto />
                    </div>
                )}
            </div>

            <div className="driver-info">
                <div className="driver-name" data-cy="tracking-driver-name">
                    {driver.name}
                </div>
                <div className="car-detail-row">
                    <FormattedMessage
                        id="car_name"
                        values={{
                            brand: car.brand,
                            model: car.model,
                        }}
                    />
                    <span className="car-detail-separator">•</span>
                    <span className="licence-plate" data-cy="tracking-driver-label">
                        {car.licencePlate}
                    </span>
                    {getColorLabel(color)}
                </div>
            </div>
        </div>
    );
}

function getColorLabel(color: string) {
    const carColor = color.toLowerCase();
    if (!carColors.includes(carColor)) {
        return null;
    }

    return (
        <span className={`vehicle color-label color-${carColor}`}>
            <FormattedMessage id={carColor} />
        </span>
    );
}
